import * as t from "./index365.js";
import * as i from "./index366.js";
import * as e from "./index367.js";
import * as m from "./index368.js";
import * as n from "./index369.js";
import * as c from "./index370.js";
import * as g from "./index371.js";
import * as f from "./index372.js";
import * as p from "./index373.js";
import * as l from "./index374.js";
import * as v from "./index375.js";
import * as d from "./index376.js";
import * as h from "./index377.js";
import * as u from "./index378.js";
import * as w from "./index379.js";
import * as y from "./index380.js";
import * as b from "./index381.js";
import * as k from "./index382.js";
import * as S from "./index383.js";
import * as T from "./index384.js";
import * as x from "./index385.js";
import * as M from "./index386.js";
import * as O from "./index387.js";
import * as j from "./index388.js";
import * as D from "./index389.js";
import * as U from "./index390.js";
import * as C from "./index391.js";
import * as E from "./index392.js";
import * as L from "./index393.js";
import * as B from "./index394.js";
import * as N from "./index395.js";
import * as R from "./index396.js";
import * as z from "./index397.js";
import * as A from "./index398.js";
import * as F from "./index399.js";
import * as I from "./index400.js";
import * as _ from "./index401.js";
import * as q from "./index402.js";
import * as G from "./index403.js";
import * as H from "./index404.js";
import * as J from "./index405.js";
import * as K from "./index406.js";
import * as W from "./index407.js";
import * as Z from "./index408.js";
import * as P from "./index409.js";
import * as Q from "./index410.js";
import * as V from "./index411.js";
import * as X from "./index412.js";
import * as Y from "./index413.js";
import * as $ from "./index414.js";
import * as ss from "./index415.js";
import * as os from "./index416.js";
import * as as from "./index417.js";
import * as rs from "./index418.js";
import * as ts from "./index419.js";
import * as is from "./index420.js";
import * as es from "./index421.js";
import * as ms from "./index422.js";
import * as ns from "./index423.js";
import * as cs from "./index424.js";
import * as gs from "./index425.js";
import * as fs from "./index426.js";
import * as ps from "./index427.js";
import * as ls from "./index428.js";
import * as vs from "./index429.js";
import * as ds from "./index430.js";
import * as hs from "./index431.js";
import * as us from "./index432.js";
import * as ws from "./index433.js";
import * as ys from "./index434.js";
import * as bs from "./index435.js";
import * as ks from "./index436.js";
import * as Ss from "./index437.js";
import * as Ts from "./index438.js";
import * as xs from "./index439.js";
import * as Ms from "./index440.js";
import * as Os from "./index441.js";
import * as js from "./index442.js";
import * as Ds from "./index443.js";
import * as Us from "./index444.js";
import * as Cs from "./index445.js";
import * as Es from "./index446.js";
import * as Ls from "./index447.js";
import * as Bs from "./index448.js";
import * as Ns from "./index449.js";
import * as Rs from "./index450.js";
import * as zs from "./index451.js";
import * as As from "./index452.js";
import * as Fs from "./index453.js";
import * as Is from "./index454.js";
import * as _s from "./index455.js";
import * as qs from "./index456.js";
import * as Gs from "./index457.js";
import * as Hs from "./index458.js";
import * as Js from "./index459.js";
import * as Ks from "./index460.js";
import * as Ws from "./index461.js";
import * as Zs from "./index462.js";
import * as Ps from "./index463.js";
import * as Qs from "./index464.js";
import * as Vs from "./index465.js";
import * as Xs from "./index466.js";
import * as Ys from "./index467.js";
import * as $s from "./index468.js";
import * as so from "./index469.js";
import * as oo from "./index470.js";
import * as ao from "./index471.js";
import * as ro from "./index472.js";
import * as to from "./index473.js";
import * as io from "./index474.js";
import * as eo from "./index475.js";
import * as mo from "./index476.js";
import * as no from "./index477.js";
import * as co from "./index478.js";
import * as go from "./index479.js";
import * as fo from "./index480.js";
import * as po from "./index481.js";
import * as lo from "./index482.js";
import * as vo from "./index483.js";
import * as ho from "./index484.js";
import * as uo from "./index485.js";
import * as wo from "./index486.js";
import * as yo from "./index487.js";
import * as bo from "./index488.js";
import * as ko from "./index489.js";
import * as So from "./index490.js";
import * as To from "./index491.js";
import * as xo from "./index492.js";
import * as Mo from "./index493.js";
import * as Oo from "./index494.js";
import * as jo from "./index495.js";
import * as Do from "./index496.js";
import * as Uo from "./index497.js";
import * as Co from "./index498.js";
import * as Eo from "./index499.js";
import * as Lo from "./index500.js";
import * as Bo from "./index501.js";
import * as No from "./index502.js";
import * as Ro from "./index503.js";
import * as zo from "./index504.js";
import * as Ao from "./index505.js";
import * as Fo from "./index506.js";
import * as Io from "./index507.js";
import * as _o from "./index508.js";
import * as qo from "./index509.js";
import * as Go from "./index510.js";
import * as Ho from "./index511.js";
import * as Jo from "./index512.js";
import * as Ko from "./index513.js";
import * as Wo from "./index514.js";
import * as Zo from "./index515.js";
import * as Po from "./index516.js";
import * as Qo from "./index517.js";
import * as Vo from "./index518.js";
import * as Xo from "./index519.js";
import * as Yo from "./index520.js";
import * as $o from "./index521.js";
import * as sa from "./index522.js";
import * as oa from "./index523.js";
const aa = /* @__PURE__ */ Object.assign({ "../../assets/icons/account-balance.svg": t, "../../assets/icons/account.svg": i, "../../assets/icons/add-symbol.svg": e, "../../assets/icons/apple-logo.svg": m, "../../assets/icons/arrow-backward-sm.svg": n, "../../assets/icons/arrow-backward.svg": c, "../../assets/icons/arrow-close.svg": g, "../../assets/icons/arrow-down-solid.svg": f, "../../assets/icons/arrow-down.svg": p, "../../assets/icons/arrow-drawer.svg": l, "../../assets/icons/arrow-forward-sm.svg": v, "../../assets/icons/arrow-forward.svg": d, "../../assets/icons/arrow-left-solid.svg": h, "../../assets/icons/arrow-open.svg": u, "../../assets/icons/arrow-outward.svg": w, "../../assets/icons/arrow-right-solid.svg": y, "../../assets/icons/arrow-right-thin.svg": b, "../../assets/icons/arrow-up-solid.svg": k, "../../assets/icons/arrow-up.svg": S, "../../assets/icons/arrow-updown-solid.svg": T, "../../assets/icons/arrow-updown.svg": x, "../../assets/icons/asset.svg": M, "../../assets/icons/calendar.svg": O, "../../assets/icons/campaign-thin.svg": j, "../../assets/icons/candlegreenred.svg": D, "../../assets/icons/candleredblue.svg": U, "../../assets/icons/card.svg": C, "../../assets/icons/cert.svg": E, "../../assets/icons/chart-1-d.svg": L, "../../assets/icons/chart-1-w.svg": B, "../../assets/icons/chart-15m.svg": N, "../../assets/icons/chart-1h.svg": R, "../../assets/icons/chart-1m.svg": z, "../../assets/icons/chart-30m.svg": A, "../../assets/icons/chart-4h.svg": F, "../../assets/icons/chart-5m.svg": I, "../../assets/icons/chart-area.svg": _, "../../assets/icons/chart-bubble.svg": q, "../../assets/icons/chart-candle.svg": G, "../../assets/icons/chart-indicator.svg": H, "../../assets/icons/chart-line.svg": J, "../../assets/icons/chart-new.svg": K, "../../assets/icons/chart-setting.svg": W, "../../assets/icons/chart-setup.svg": Z, "../../assets/icons/chart.svg": P, "../../assets/icons/check-circle.svg": Q, "../../assets/icons/check-mark.svg": V, "../../assets/icons/check-sm.svg": X, "../../assets/icons/close small.svg": Y, "../../assets/icons/close-thin.svg": $, "../../assets/icons/close.svg": ss, "../../assets/icons/cloud-upload.svg": os, "../../assets/icons/comm.svg": as, "../../assets/icons/copy.svg": rs, "../../assets/icons/delete.svg": ts, "../../assets/icons/deposit-thin.svg": is, "../../assets/icons/description.svg": es, "../../assets/icons/desktop.svg": ms, "../../assets/icons/dollar.svg": ns, "../../assets/icons/download.svg": cs, "../../assets/icons/drag-draw.svg": gs, "../../assets/icons/edit.svg": fs, "../../assets/icons/email.svg": ps, "../../assets/icons/external-link.svg": ls, "../../assets/icons/eye-close.svg": vs, "../../assets/icons/eye.svg": ds, "../../assets/icons/faq-thin.svg": hs, "../../assets/icons/fav.svg": us, "../../assets/icons/favorite.svg": ws, "../../assets/icons/file-attached.svg": ys, "../../assets/icons/filter.svg": bs, "../../assets/icons/fullscreen.svg": ks, "../../assets/icons/globe.svg": Ss, "../../assets/icons/grab.svg": Ts, "../../assets/icons/grade.svg": xs, "../../assets/icons/heart-thin.svg": Ms, "../../assets/icons/heart.svg": Os, "../../assets/icons/home.svg": js, "../../assets/icons/icn-delete.svg": Ds, "../../assets/icons/info-thin.svg": Us, "../../assets/icons/info.svg": Cs, "../../assets/icons/iphone.svg": Es, "../../assets/icons/layout-1x1.svg": Ls, "../../assets/icons/layout-2x2.svg": Bs, "../../assets/icons/layout-3x3.svg": Ns, "../../assets/icons/layout-4x4.svg": Rs, "../../assets/icons/list-thin.svg": zs, "../../assets/icons/list.svg": As, "../../assets/icons/login.svg": Fs, "../../assets/icons/logout-thin.svg": Is, "../../assets/icons/logout.svg": _s, "../../assets/icons/minus.svg": qs, "../../assets/icons/mode-dark.svg": Gs, "../../assets/icons/mode-light.svg": Hs, "../../assets/icons/more vert.svg": Js, "../../assets/icons/move.svg": Ks, "../../assets/icons/mypage-thin.svg": Ws, "../../assets/icons/mypage.svg": Zs, "../../assets/icons/notification.svg": Ps, "../../assets/icons/order.svg": Qs, "../../assets/icons/person.svg": Vs, "../../assets/icons/phone.svg": Xs, "../../assets/icons/play-store.svg": Ys, "../../assets/icons/plus-minus.svg": $s, "../../assets/icons/plus.svg": so, "../../assets/icons/refresh.svg": oo, "../../assets/icons/save.svg": ao, "../../assets/icons/screen-multi.svg": ro, "../../assets/icons/screen-multi2.svg": to, "../../assets/icons/screen-single.svg": io, "../../assets/icons/search.svg": eo, "../../assets/icons/send.svg": mo, "../../assets/icons/settings.svg": no, "../../assets/icons/shield.svg": co, "../../assets/icons/sort.svg": go, "../../assets/icons/star.svg": fo, "../../assets/icons/support-thin.svg": po, "../../assets/icons/support.svg": lo, "../../assets/icons/time.svg": vo, "../../assets/icons/trade-thin.svg": ho, "../../assets/icons/trade.svg": uo, "../../assets/icons/transparent.svg": wo, "../../assets/icons/trash-thin.svg": yo, "../../assets/icons/trash.svg": bo, "../../assets/icons/trending-down.svg": ko, "../../assets/icons/trending-up.svg": So, "../../assets/icons/upload.svg": To, "../../assets/icons/warning.svg": xo, "../../assets/icons/warning2.svg": Mo, "../../assets/icons/watch.svg": Oo, "../../assets/icons/withdraw.svg": jo }), ra = /* @__PURE__ */ Object.assign({ "../../assets/icons/flags/flag-au.svg": Do, "../../assets/icons/flags/flag-ca.svg": Uo, "../../assets/icons/flags/flag-cn.svg": Co, "../../assets/icons/flags/flag-de.svg": Eo, "../../assets/icons/flags/flag-es.svg": Lo, "../../assets/icons/flags/flag-eu.svg": Bo, "../../assets/icons/flags/flag-fr.svg": No, "../../assets/icons/flags/flag-hk.svg": Ro, "../../assets/icons/flags/flag-it.svg": zo, "../../assets/icons/flags/flag-jp.svg": Ao, "../../assets/icons/flags/flag-kr.svg": Fo, "../../assets/icons/flags/flag-mx.svg": Io, "../../assets/icons/flags/flag-nl.svg": _o, "../../assets/icons/flags/flag-nr.svg": qo, "../../assets/icons/flags/flag-nz.svg": Go, "../../assets/icons/flags/flag-se.svg": Ho, "../../assets/icons/flags/flag-sg.svg": Jo, "../../assets/icons/flags/flag-sui.svg": Ko, "../../assets/icons/flags/flag-tr.svg": Wo, "../../assets/icons/flags/flag-uk.svg": Zo, "../../assets/icons/flags/flag-us.svg": Po, "../../assets/icons/flags/flag-za.svg": Qo }), ta = /* @__PURE__ */ Object.assign({ "../../assets/icons/trade/candle-greenred.svg": Vo, "../../assets/icons/trade/candle-redblue.svg": Xo }), ia = /* @__PURE__ */ Object.assign({ "../../assets/icons/notification/notification-event.svg": Yo, "../../assets/icons/notification/notification-security.svg": $o, "../../assets/icons/notification/notification-system.svg": sa, "../../assets/icons/notification/notification-trade.svg": oa }), r = /* @__PURE__ */ new Map();
Object.entries(aa).forEach(([o, a]) => {
  const s = o.split("/").pop()?.replace(".svg", "");
  s && r.set(s, a.default);
});
Object.entries(ra).forEach(([o, a]) => {
  const s = o.split("/").pop()?.replace(".svg", "");
  s && r.set(s, a.default);
});
Object.entries(ta).forEach(([o, a]) => {
  const s = o.split("/").pop()?.replace(".svg", "");
  s && r.set(s, a.default);
});
Object.entries(ia).forEach(([o, a]) => {
  const s = o.split("/").pop()?.replace(".svg", "");
  s && r.set(s, a.default);
});
const ea = (o) => r.get(o) || null;
export {
  ea as getIconComponent,
  r as iconRegistry
};
